<div class="chot-buoi-container">
  <!-- History Section - Danh sách đã chốt -->
  <div class="card mb-3 history-card">
    <div class="card-header bg-info text-white">
      <div class="d-flex align-items-center justify-content-between">
        <div>
          <i class="fas fa-history mr-2"></i>
          <strong>Lịch sử chốt số buổi học</strong>
        </div>
        <span class="badge badge-light">{{datas?.length || 0}} bản ghi</span>
      </div>
    </div>
    <div class="card-body p-0">
      <div class="table-wrapper">
        <table class="table table-hover table-sm mb-0">
          <thead class="thead-light">
            <tr>
              <th style="width:50px;text-align:center">STT</th>
              <th style="min-width:150px">
                <i class="fas fa-chalkboard-teacher mr-1"></i>Lớp
              </th>
              <th style="min-width:110px">
                <i class="fas fa-calendar-alt mr-1"></i>Ngày tạo
              </th>
              <th style="min-width:110px">
                <i class="fas fa-user mr-1"></i>Người tạo
              </th>
              <th style="min-width:90px;text-align:center">
                <i class="fas fa-book-reader mr-1"></i>Số buổi
              </th>
              <th style="min-width:150px">
                <i class="fas fa-sticky-note mr-1"></i>Ghi chú
              </th>
              <th style="width:80px;text-align:center">
                <i class="fas fa-cog"></i>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let u of datas; let i = index" 
                (click)="selected(u)" 
                [class.selected-row]="u.selected"
                class="data-row">
              <td style="text-align:center">
                <span class="badge badge-secondary">{{u.STT}}</span>
              </td>
              <td>
                <strong>{{u.TenLop}}</strong>
              </td>
              <td>
                <span class="text-muted">
                  <i class="far fa-calendar mr-1"></i>
                  {{u.Created | date:'dd/MM/yyyy'}}
                </span>
              </td>
              <td>{{u.CreatedBy}}</td>
              <td style="text-align:center">
                <span class="badge badge-success badge-pill">
                  {{u.SoBuoi}} buổi
                </span>
              </td>
              <td>
                <span class="text-muted">{{u.GhiChu}}</span>
              </td>
              <td style="text-align:center">
                <button type="button" 
                        class="btn btn-sm btn-outline-danger" 
                        (click)="deleterow(i)" 
                        title="Xóa dòng">
                  <i class="far fa-trash-alt"></i>
                </button>
              </td>
            </tr>
            <tr *ngIf="!datas || datas.length === 0">
              <td colspan="7" class="text-center text-muted py-4">
                <i class="fas fa-inbox fa-2x mb-2 d-block"></i>
                Chưa có dữ liệu chốt số buổi
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>

  <!-- Input Form Section - Thêm mới chốt buổi -->
  <div class="card input-form-card">
    <div class="card-header bg-primary text-white">
      <i class="fas fa-plus-circle mr-2"></i>
      <strong>Thêm mới chốt số buổi học</strong>
    </div>
    <div class="card-body">
      <div class="row">
        <!-- Ngày tạo -->
        <div class="col-md-6">
          <div class="form-group">
            <label class="control-label">
              <i class="fas fa-calendar-check text-primary mr-1"></i>
              {{'Ngày tạo' | translate}}
              <span class="text-danger">(*)</span>
            </label>
            <kendo-dateinput 
              tabindex="1" 
              style="width:100%;" 
              [format]="'dd/MM/yyyy'" 
              [(value)]="doituongSelect.Created"
              class="form-control-custom">
            </kendo-dateinput>
          </div>
        </div>

        <!-- Người tạo -->
        <div class="col-md-6">
          <div class="form-group">
            <label class="control-label">
              <i class="fas fa-user-check text-primary mr-1"></i>
              {{'Người tạo' | translate}}
            </label>
            <input 
              type="text" 
              tabIndex="2" 
              class="form-control" 
              placeholder="Người tạo" 
              disabled="disabled" 
              [(ngModel)]="doituongSelect.CreatedBy">
          </div>
        </div>
      </div>

      <div class="row">
        <!-- Lớp -->
        <div class="col-md-8">
          <div class="form-group">
            <label class="control-label">
              <i class="fas fa-chalkboard-teacher text-primary mr-1"></i>
              {{'Lớp' | translate}}
              <span class="text-danger">(*)</span>
            </label>
            <ng-select 
              #slLop
              [tabIndex]="3"
              [openOnEnter]="false"
              [items]="dslops"
              bindValue="Id"
              bindLabel="Ten"
              notFoundText="Không có dữ liệu"
              placeholder="Chọn lớp học..."
              [searchFn]="comboSearchFn2"
              [(ngModel)]="doituongSelect.LopId">
              <ng-template ng-option-tmp let-item="item">
                <div class="select-option">
                  <i class="fas fa-graduation-cap mr-2"></i>
                  {{item.Ten}}
                </div>
              </ng-template>
            </ng-select>
          </div>
        </div>

        <!-- Số buổi -->
        <div class="col-md-4">
          <div class="form-group">
            <label class="control-label">
              <i class="fas fa-book-reader text-primary mr-1"></i>
              {{'Số buổi' | translate}}
              <span class="text-danger">(*)</span>
            </label>
            <input 
              class="form-control text-right font-weight-bold"
              maxlength="20"
              tabindex="4"
              currencyMask
              [(ngModel)]="doituongSelect.SoBuoi"
              name="value"
              placeholder="Nhập số buổi..."
              [options]="ngxCurrencyOptions" 
              autocomplete="off" />
          </div>
        </div>
      </div>

      <!-- Ghi chú -->
      <div class="row">
        <div class="col-12">
          <div class="form-group mb-0">
            <label class="control-label">
              <i class="fas fa-sticky-note text-primary mr-1"></i>
              {{'Ghi chú' | translate}}
            </label>
            <textarea 
              type="text" 
              tabindex="5" 
              class="form-control" 
              rows="3" 
              placeholder="Nhập ghi chú (nếu có)..."
              [(ngModel)]="doituongSelect.GhiChu">
            </textarea>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Footer Actions -->
<div class="modal-footer border-top bg-light">
  <div class="d-flex justify-content-between align-items-center w-100">
    <div>
      <small class="text-muted">
        <i class="fas fa-info-circle mr-1"></i>
        Các trường có dấu (*) là bắt buộc
      </small>
    </div>
    <div class="btn-group-actions">
      <button 
        class="btn btn-secondary" 
        (click)="closeModal()" 
        title="Ấn ESC để thoát">
        <i class="fas fa-times mr-1"></i>
        Hủy bỏ
      </button>
      <button 
        type="submit" 
        (click)="LamMoi()" 
        class="btn btn-warning">
        <i class="fas fa-sync-alt mr-1"></i>
        Làm mới
      </button>
      <button 
        type="submit" 
        (click)="ThucHien()" 
        class="btn btn-primary">
        <i class="fas fa-save mr-1"></i>
        Lưu lại
      </button>
    </div>
  </div>
</div>
